/**
 * @generated SignedSource<<40293366a861d7044d181855125663b7>>
 * @relayHash e4e54828251309a9de86334b932053b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d486b68b5d188b9237165eec25fecdb1cc8f665f182dcb05ee298672078077fd

import type { ConcreteRequest } from 'relay-runtime';
export type AgentAICitationSourceType = "KB_ARTICLE" | "SIMILAR_ISSUE" | "%future added value";
export type graphqlContextPanelQuery$variables = {
  cloudId: string;
  issueId?: string | null;
};
export type graphqlContextPanelQuery$data = {
  readonly agentAI_contextPanel: {
    readonly __typename: "AgentAIContextPanelResponse";
    readonly agentSteps: string | null;
    readonly reporterDetails: string | null;
    readonly suggestedActions: ReadonlyArray<{
      readonly content: {
        readonly description: string | null;
        readonly title: string | null;
      } | null;
      readonly context: {
        readonly currentValue: AGG$JSON | null;
        readonly fieldId: string | null;
        readonly fieldName: string | null;
        readonly fieldType: string | null;
        readonly suggestion: AGG$JSON | null;
      } | null;
      readonly type: string | null;
    } | null> | null;
    readonly suggestedNextSteps: {
      readonly citations: ReadonlyArray<{
        readonly id: string;
        readonly sourceId: string | null;
        readonly sourceType: AgentAICitationSourceType;
        readonly sourceUrl: string;
        readonly title: string;
      } | null>;
      readonly nextSteps: ReadonlyArray<{
        readonly content: string;
        readonly inlineAction: {
          readonly draftReplyPill: {
            readonly category: string;
            readonly example: string | null;
            readonly goal: string | null;
            readonly intent: string | null;
            readonly pillId: string;
            readonly text: string;
            readonly triggerSummary: string | null;
          } | null;
          readonly type: string;
        } | null;
      } | null>;
    } | null;
    readonly summary: string | null;
  } | {
    readonly __typename: "QueryError";
    readonly extensions: ReadonlyArray<{
      readonly errorType: string | null;
      readonly statusCode: number | null;
    }> | null;
    readonly message: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type graphqlContextPanelQuery = {
  response: graphqlContextPanelQuery$data;
  variables: graphqlContextPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "issueId",
    "variableName": "issueId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "type"
},
v4 = {
  "kind": "ScalarField",
  "name": "title"
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "summary"
    },
    {
      "kind": "ScalarField",
      "name": "agentSteps"
    },
    {
      "kind": "ScalarField",
      "name": "reporterDetails"
    },
    {
      "concreteType": "AgentAISuggestAction",
      "kind": "LinkedField",
      "name": "suggestedActions",
      "plural": true,
      "selections": [
        (v3/*: any*/),
        {
          "concreteType": "AgentAISuggestedActionContent",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "kind": "ScalarField",
              "name": "description"
            }
          ]
        },
        {
          "concreteType": "AgentAISuggestedActionContext",
          "kind": "LinkedField",
          "name": "context",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "fieldId"
            },
            {
              "kind": "ScalarField",
              "name": "fieldType"
            },
            {
              "kind": "ScalarField",
              "name": "fieldName"
            },
            {
              "kind": "ScalarField",
              "name": "suggestion"
            },
            {
              "kind": "ScalarField",
              "name": "currentValue"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "AgentAISuggestedNextSteps",
      "kind": "LinkedField",
      "name": "suggestedNextSteps",
      "plural": false,
      "selections": [
        {
          "concreteType": "AgentAICitation",
          "kind": "LinkedField",
          "name": "citations",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "id"
            },
            {
              "kind": "ScalarField",
              "name": "sourceId"
            },
            {
              "kind": "ScalarField",
              "name": "sourceType"
            },
            {
              "kind": "ScalarField",
              "name": "sourceUrl"
            },
            (v4/*: any*/)
          ]
        },
        {
          "concreteType": "AgentAINextStep",
          "kind": "LinkedField",
          "name": "nextSteps",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "content"
            },
            {
              "concreteType": "AgentAIInlineAction",
              "kind": "LinkedField",
              "name": "inlineAction",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "concreteType": "AgentAIDraftReplyPillData",
                  "kind": "LinkedField",
                  "name": "draftReplyPill",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "category"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "example"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "goal"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "intent"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "pillId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "text"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "triggerSummary"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "AgentAIContextPanelResponse"
},
v6 = {
  "kind": "ScalarField",
  "name": "message"
},
v7 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v8 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "graphqlContextPanelQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "agentAI_contextPanel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/)
                ]
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "graphqlContextPanelQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "agentAI_contextPanel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ]
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d486b68b5d188b9237165eec25fecdb1cc8f665f182dcb05ee298672078077fd",
    "metadata": {},
    "name": "graphqlContextPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ea8e294e11dc4182f22cbc945fd9a47a";

export default node;
